// extracted by mini-css-extract-plugin
module.exports = {"loadingAnimation":"Loader_loadingAnimation__3xyfJ","normal":"Loader_normal__1QB0E","loading-animation":"Loader_loading-animation__NhT-b","small":"Loader_small__1IoLj"};